/* unplugin-vue-components disabled */import { render } from "./ScenicFoodInfoDetail.vue?vue&type=template&id=f20dcd50&ts=true"
import script from "./ScenicFoodInfoDetail.vue?vue&type=script&lang=ts"
export * from "./ScenicFoodInfoDetail.vue?vue&type=script&lang=ts"

import "./ScenicFoodInfoDetail.vue?vue&type=style&index=0&id=f20dcd50&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__